import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-3 flex items-center gap-3" }
const _hoisted_2 = { class: "flex-1 text-xs text-gray-500" }
const _hoisted_3 = { class: "grid items-start gap-4 xl:grid-cols-[minmax(0,1fr)_17rem]" }
const _hoisted_4 = { class: "space-y-4" }

import { ArrowPathIcon } from '@heroicons/vue/20/solid'
import { computed, ref } from 'vue'

import ColorPanel from './ColorPanel.vue'
import EmbedPreview from './EmbedPreview.vue'
import WordingPanel from './WordingPanel.vue'


export default {
  __name: 'ChannelDesigner',
  props: {
  channel: { type: String, required: true },
  scriptUrl: { type: String, default: '' },
  config: { type: Object, required: true },
  colors: { type: Object, required: true },
  defaults: { type: Object, required: true },
  elements: { type: Array, required: true },
  hint: { type: String, default: '' },
  texts: { type: Array, default: () => [] },
  alignment: { type: Object, default: null },
  wordingDefaults: { type: Object, default: () => ({}) }
},
  emits: ['update:colors', 'update:alignment', 'edit'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const preview = ref(null)
const highlight = ref(null)

const wording = computed(() =>
  props.texts.map(({ field, label, align }) => ({
    field,
    label,
    value: props.config[field],
    ...(align && props.alignment ? { align: props.alignment[align] || 'left' } : {})
  }))
)

const realign = (field, value) => {
  const part = props.texts.find(text => text.field === field)?.align
  if (part) emit('update:alignment', { ...props.alignment, [part]: value })
}

const wordingChanged = computed(
  () =>
    props.texts.some(({ field }) => (props.config[field] ?? '') !== (props.wordingDefaults[field] ?? '')) ||
    Object.keys(props.alignment ?? {}).length > 0
)

const resetWording = () => {
  props.texts.forEach(({ field }) => {
    if (field in props.wordingDefaults) emit('edit', field, props.wordingDefaults[field])
  })
  if (props.alignment) emit('update:alignment', {})
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(__props.hint), 1),
      _createElementVNode("button", {
        type: "button",
        class: "inline-flex shrink-0 items-center gap-1 text-xs font-medium text-gray-500 hover:text-gray-900",
        onClick: _cache[0] || (_cache[0] = $event => (preview.value?.restart()))
      }, [
        _createVNode(_unref(ArrowPathIcon), {
          class: "h-3.5 w-3.5",
          "aria-hidden": "true"
        }),
        _createTextVNode(" " + _toDisplayString(__props.channel === 'chat' ? 'Refresh chat' : 'Refresh form'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (__props.scriptUrl)
        ? (_openBlock(), _createBlock(EmbedPreview, {
            key: 0,
            ref_key: "preview",
            ref: preview,
            channel: __props.channel,
            "script-url": __props.scriptUrl,
            config: __props.config,
            highlight: highlight.value,
            onEdit: _cache[1] || (_cache[1] = (field, value) => emit('edit', field, value))
          }, null, 8, ["channel", "script-url", "config", "highlight"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (wording.value.length)
          ? (_openBlock(), _createBlock(WordingPanel, {
              key: 0,
              items: wording.value,
              resettable: wordingChanged.value,
              onEdit: _cache[2] || (_cache[2] = field => preview.value?.focusText(field)),
              onAlign: realign,
              onReset: resetWording
            }, null, 8, ["items", "resettable"]))
          : _createCommentVNode("", true),
        _createVNode(ColorPanel, {
          "model-value": __props.colors,
          defaults: __props.defaults,
          elements: __props.elements,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (emit('update:colors', $event))),
          onHighlight: _cache[4] || (_cache[4] = $event => (highlight.value = $event))
        }, null, 8, ["model-value", "defaults", "elements"])
      ])
    ])
  ]))
}
}

}